export const getQueryStringParamValue = (key) => {
    if (typeof window !== 'undefined') {
        const url = new URL(window.location.href);
        return url.searchParams.get(key) || '';
    }
};
/**
 * Removes query string parameters from URL
 * @param {URL} url - URL to clean
 * @returns {string} - URL with now query strings
 */
export const getCleanedURL = (url) => `${url.protocol}//${url.host}${url.pathname}`;
export const QueryStringToObject = (str) => {
    const obj = {};
    const params = str.split(',');
    params.forEach((param) => {
        const kvp = param.split('=');
        obj[kvp[0]] = kvp[1];
    });
    return obj;
};
/**
 * A very specific function that will retrieve a zip/zipcode/zipCode query string parameter value from the URL, if it exists. Otherwise returns an empty string.
 * @returns {string} - The found zip/zipcode/zipCode value or empty string.
 */
export const getZipCodeQueryStringParam = () => {
    return getQueryStringParamValue('zip') || getQueryStringParamValue('zipcode') || getQueryStringParamValue('zipCode');
};
